import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getCorporateIntegrityDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  managementIntegrityMessagePageContent: [
    {
      fieldName: "Image",
      fieldValue: "data.image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Text (EN)",
      fieldValue: "data.text",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_text",
      formType: "input",
      label: "Text (EN)",
      placeholder: "",
      validation: { required: "(EN)Text is required" },
    },
    // {
    //   fieldName: "Image (MS)",
    //   fieldValue: "data.image",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_ms_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image (MS)",
    //   placeholder: "",
    //   validation: {},
    // },
    {
      fieldName: "Text (MS)",
      fieldValue: "data.text",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_text",
      formType: "input",
      label: "Text (MS)",
      placeholder: "Enter text (MS)",
      validation: {},
    },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   validation: {},
    // },
    // {
    //   fieldName: "Image (ZH)",
    //   fieldValue: "data.image",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_zh_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image (ZH)",
    //   placeholder: "",
    //   validation: {},
    // },
    {
      fieldName: "Text (ZH)",
      fieldValue: "data.text",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_text",
      formType: "input",
      label: "Text (ZH)",
      placeholder: "Enter text (ZH)",
      validation: {},
    },
    //     {
    //       fieldName: "Next Page Name (EN)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (EN)",
    //       placeholder: "Enter Next Page Name (EN)",
    //       validation: { required: " Next Page Name (EN) is required" },
    //     },
    //     {
    //       fieldName: "Next Page Name (MS)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_malay",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_ms_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (MS)",
    //       placeholder: "Enter Next Page Name (MS)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Name (ZH)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_mandarin",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_zh_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (ZH)",
    //       placeholder: "Enter Next Page Name (ZH)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Link",
    //       fieldValue: "data.nextPage.link",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_link",
    //       formType: "input",
    //       label: "Next Page Link",
    //       placeholder: "Enter Next Page Link",
    //       validation: { required: "Next Page Link is required", validate: (value: string) => {
    //   const trimmed = value.trim();
    //   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
    //   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    //     return "Looks like an external link. Please use an in-app page link, such as /example";
    //   }
    //   return true;
    // } },
    //     },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  managementIntegrityMessagePageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      // validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  managementIntegrityMessageNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: " Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      validation: {},
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter Next Page Link",
      validation: {
        required: "Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  antiBriberyCorruptionPageContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Intro Text (EN)",
      fieldValue: "data.introText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_introText",
      formType: "richText",
      label: "Intro Text (EN)",
      placeholder: "Enter Intro Text (EN)",
      validation: { required: "Intro Text (EN) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "data.description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Extro Text (EN)",
      fieldValue: "data.extroText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_extroText",
      formType: "richText",
      label: "Extro Text (EN)",
      placeholder: "Enter Extro Text (EN)",
      validation: { required: "Extro Text (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "data.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "",
      validation: {},
    },
    {
      fieldName: "Intro Text (MS)",
      fieldValue: "data.introText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_introText",
      formType: "richText",
      label: "Intro Text (MS)",
      placeholder: "Enter Intro Text (MS)",
      validation: {},
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "data.description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      validation: {},
    },
    {
      fieldName: "Extro Text (MS)",
      fieldValue: "data.extroText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_extroText",
      formType: "richText",
      label: "Extro Text (MS)",
      placeholder: "Enter Extro Text (MS)",
      validation: {},
    },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   validation: {},
    // },
    {
      fieldName: "Title (ZH)",
      fieldValue: "data.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      validation: {},
    },
    {
      fieldName: "Intro Text (MS)",
      fieldValue: "data.introText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_introText",
      formType: "richText",
      label: "Intro Text (MS)",
      placeholder: "Enter Intro Text (MS)",
      validation: {},
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "data.description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_description",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      validation: {},
    },
    {
      fieldName: "Extro Text (ZH)",
      fieldValue: "data.extroText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_extroText",
      formType: "richText",
      label: "Extro Text (ZH)",
      placeholder: "Enter Extro Text (ZH)",
      validation: {},
    },
    //     {
    //       fieldName: "Next Page Name (EN)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (EN)",
    //       placeholder: "Enter Next Page Name (EN)",
    //       validation: { required: " Next Page Name (EN) is required" },
    //     },
    //     {
    //       fieldName: "Next Page Name (MS)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_malay",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_ms_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (MS)",
    //       placeholder: "Enter Next Page Name (MS)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Name (ZH)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_mandarin",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_zh_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (ZH)",
    //       placeholder: "Enter Next Page Name (ZH)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Link",
    //       fieldValue: "data.nextPage.link",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_link",
    //       formType: "input",
    //       label: "Next Page Link",
    //       placeholder: "Enter Next Page Link",
    //       validation: { required: "Next Page Link is required", validate: (value: string) => {
    //   const trimmed = value.trim();
    //   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
    //   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    //     return "Looks like an external link. Please use an in-app page link, such as /example";
    //   }
    //   return true;
    // } },
    //     },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  antiBriberyCorruptionPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      // validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  antiBriberyCorruptionNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: " Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      validation: {},
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter Next Page Link",
      validation: {
        required: "Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  whistleblowingProgramPageContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "data.descriptions",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_descriptions",
      formType: "richText",
      label: "Description (EN)s",
      placeholder: "Enter Description (EN)s",
      validation: { required: "Description (EN)s is required" },
    },
    {
      fieldName: "WIC Structure Image",
      fieldValue: "data.wicStructure.image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_wicStructure_image",
      formType: "file",
      usedFileType: "image/*",
      label: "WIC Structure Image",
      placeholder: "",
      validation: { required: "WIC Structure  Image is required" },
    },
    {
      fieldName: "WIC Structure Title (EN)",
      fieldValue: "data.wicStructure.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_wicStructure_title",
      formType: "input",
      label: "WIC Structure Title (EN)",
      placeholder: "Enter WIC Structure Title (EN)",
      validation: { required: "WIC Structure Title (EN) is required" },
    },
    {
      fieldName: "Whistleblowing Procedure Image",
      fieldValue: "data.procedure.image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_procedure_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Whistleblowing Procedure Image",
      placeholder: "",
      validation: { required: "Whistleblowing Procedure  Image is required" },
    },
    {
      fieldName: "Whistleblowing Procedure Title (EN)",
      fieldValue: "data.procedure.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_procedure_title",
      formType: "input",
      label: "Whistleblowing Procedure Title (EN)",
      placeholder: "Enter Whistleblowing Procedure Title (EN)",
      validation: { required: "Whistleblowing Procedure Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "data.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      validation: {},
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "data.descriptions",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_descriptions",
      formType: "richText",
      label: "Description (MS)s",
      placeholder: "Enter Description (MS)s",
      validation: {},
    },
    // {
    //   fieldName: "WIC Structure Image (MS)",
    //   fieldValue: "data.wicStructure.image",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_ms_wicStructure_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "WIC Structure Image (MS)",
    //   placeholder: "",
    //   // validation: {},
    // },
    {
      fieldName: "WIC Structure Title (MS)",
      fieldValue: "data.wicStructure.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_wicStructure_title",
      formType: "input",
      label: "WIC Structure Title (MS)",
      placeholder: "Enter WIC Structure Title (MS)",
      validation: {},
    },
    // {
    //   fieldName: "Whistleblowing Procedure Image (MS)",
    //   fieldValue: "data.procedure.image",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_ms_procedure_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Whistleblowing Procedure Image (MS)",
    //   placeholder: "",
    //   // validation: {},
    // },
    {
      fieldName: "Whistleblowing Procedure Title (MS)",
      fieldValue: "data.procedure.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_procedure_title",
      formType: "input",
      label: "Whistleblowing Procedure Title (MS)",
      placeholder: "Enter Whistleblowing Procedure Title (MS)",
      validation: {},
    },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   validation: {},
    // },
    {
      fieldName: "Title (ZH)",
      fieldValue: "data.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      validation: {},
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "data.descriptions",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_descriptions",
      formType: "richText",
      label: "Description (ZH)s",
      placeholder: "Enter Description (ZH)s",
      validation: {},
    },
    // {
    //   fieldName: "WIC Structure Image (ZH)",
    //   fieldValue: "data.wicStructure.image",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_zh_wicStructure_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "WIC Structure Image (ZH)",
    //   placeholder: "",
    //   // validation: {},
    // },
    {
      fieldName: "WIC Structure Title (ZH)",
      fieldValue: "data.wicStructure.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_wicStructure_title",
      formType: "input",
      label: "WIC Structure Title (ZH)",
      placeholder: "Enter WIC Structure Title (ZH)",
      // validation: {},
    },
    // {
    //   fieldName: "Whistleblowing Procedure Image (ZH)",
    //   fieldValue: "data.procedure.image",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_zh_procedure_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Whistleblowing Procedure Image (ZH)",
    //   placeholder: "",
    //   // validation: {},
    // },
    {
      fieldName: "Whistleblowing Procedure Title (ZH)",
      fieldValue: "data.procedure.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_procedure_title",
      formType: "input",
      label: "Whistleblowing Procedure Title (ZH)",
      placeholder: "Enter Whistleblowing Procedure Title (ZH)",
      validation: {},
    },
    //     {
    //       fieldName: "Next Page Name (EN)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (EN)",
    //       placeholder: "Enter Next Page Name (EN)",
    //       validation: { required: " Next Page Name (EN) is required" },
    //     },
    //     {
    //       fieldName: "Next Page Name (MS)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_malay",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_ms_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (MS)",
    //       placeholder: "Enter Next Page Name (MS)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Name (ZH)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_mandarin",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_zh_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (ZH)",
    //       placeholder: "Enter Next Page Name (ZH)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Link",
    //       fieldValue: "data.nextPage.link",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_link",
    //       formType: "input",
    //       label: "Next Page Link",
    //       placeholder: "Enter Next Page Link",
    //       validation: { required: "Next Page Link is required", validate: (value: string) => {
    //   const trimmed = value.trim();
    //   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
    //   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    //     return "Looks like an external link. Please use an in-app page link, such as /example";
    //   }
    //   return true;
    // } },
    //     },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  whistleblowingProgramPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      // validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  whistleblowingProgramNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: " Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      validation: {},
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter Next Page Link",
      validation: {
        required: "Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  whistleblowingPolicyPageContent: [
    {
      fieldName: "Markup (EN)",
      fieldValue: "data.markup",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_markup",
      formType: "richText",
      label: "Markup (EN)",
      placeholder: "Enter Markup (EN)",
      validation: { required: "Markup (EN) is required" },
    },
    {
      fieldName: "Markup (MS)",
      fieldValue: "data.markup",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_markup",
      formType: "richText",
      label: "Markup (MS)",
      placeholder: "Enter Markup (MS)",
      validation: {},
    },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   validation: {},
    // },
    {
      fieldName: "Markup (ZH)",
      fieldValue: "data.markup",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_markup",
      formType: "richText",
      label: "Markup (ZH)",
      placeholder: "Enter Markup (ZH)",
      validation: {},
    },
    //     {
    //       fieldName: "Next Page Name (EN)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (EN)",
    //       placeholder: "Enter Next Page Name (EN)",
    //       validation: { required: " Next Page Name (EN) is required" },
    //     },
    //     {
    //       fieldName: "Next Page Name (MS)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_malay",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_ms_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (MS)",
    //       placeholder: "Enter Next Page Name (MS)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Name (ZH)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_mandarin",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_zh_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (ZH)",
    //       placeholder: "Enter Next Page Name (ZH)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Link",
    //       fieldValue: "data.nextPage.link",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_link",
    //       formType: "input",
    //       label: "Next Page Link",
    //       placeholder: "Enter Next Page Link",
    //       validation: { required: "Next Page Link is required", validate: (value: string) => {
    //   const trimmed = value.trim();
    //   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
    //   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    //     return "Looks like an external link. Please use an in-app page link, such as /example";
    //   }
    //   return true;
    // } },
    //     },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  whistleblowingPolicyPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      // validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  whistleblowingPolicyNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: " Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      validation: {},
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter Next Page Link",
      validation: {
        required: "Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  reportingConcernPageContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "data.description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "After Submit Success Message (EN)",
      fieldValue: "data.afterSubmit.succesMessage",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_after_submit_succesMessage",
      formType: "input",
      label: "After Submit Success Message (EN)",
      placeholder: "Enter After Submit Success Message (EN)",
      validation: { required: "After Submit Success Message (EN) is required" },
    },
    {
      fieldName: "After Submit Appreciation Message (EN)",
      fieldValue: "data.afterSubmit.appreciationMessage",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_after_submit_appreciationMessage",
      formType: "input",
      label: "After Submit Appreciation Message (EN)",
      placeholder: "Enter After Submit Appreciation Message (EN)",
      validation: { required: "After Submit Appreciation Message (EN) is required" },
    },
    {
      fieldName: "After Submit Back To Form (EN)",
      fieldValue: "data.afterSubmit.backToForm",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_after_submit_backToForm",
      formType: "input",
      label: "After Submit Back To Form Message (EN)",
      placeholder: "Enter After Submit Back To Form Message (EN)",
      validation: { required: "After Submit Back To Form Message (EN) is required" },
    },
    {
      fieldName: "Person Title text (EN)",
      fieldValue: "labelData.persons.titleText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_persons_titleText",
      formType: "input",
      label: "Person Title text (EN)",
      placeholder: "Enter Person Title text (EN)",
      validation: { required: "Person Title text (EN) is required" },
    },
    {
      fieldName: "Person Name Field text (EN)",
      fieldValue: "labelData.persons.nameFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_persons_nameFieldText",
      formType: "input",
      label: "Person Name Field text (EN)",
      placeholder: "Enter Person Name Field text (EN)",
      validation: { required: "Person Name Field text (EN) is required" },
    },
    {
      fieldName: "Person Designation Field text (EN)",
      fieldValue: "labelData.persons.designationFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_persons_designationFieldText",
      formType: "input",
      label: "Person Designation Field text (EN)",
      placeholder: "Enter Person Designation Field text (EN)",
      validation: { required: "Person Designation Field text (EN) is required" },
    },
    {
      fieldName: "Person Division/Unit Field text (EN)",
      fieldValue: "labelData.persons.divisionOrUnitFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_persons_divisionOrUnitFieldText",
      formType: "input",
      label: "Person Division/Unit Field text (EN)",
      placeholder: "Enter Person Division/Unit Field text (EN)",
      validation: { required: "Person Division/Unit Field text (EN) is required" },
    },
    {
      fieldName: "Person Company/Airport text (EN)",
      fieldValue: "labelData.persons.companyOrAirportFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_persons_companyOrAirportFieldText",
      formType: "input",
      label: "Person Company/Airport text (EN)",
      placeholder: "Enter Person Company/Airport text (EN)",
      validation: { required: "Person Company/Airport text (EN) is required" },
    },
    {
      fieldName: "Concerns Title text (EN)",
      fieldValue: "labelData.concerns.titleText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_concerns_titleText",
      formType: "input",
      label: "Concerns Title text (EN)",
      placeholder: "Enter Concerns Title text (EN)",
      validation: { required: "Concerns Title text (EN) is required" },
    },
    {
      fieldName: "Concerns Date Time Field text (EN)",
      fieldValue: "labelData.concerns.dateTimeFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_concerns_dateTimeFieldText",
      formType: "input",
      label: "Concerns Date Time Field text (EN)",
      placeholder: "Enter Concerns Date Time Field text (EN)",
      validation: { required: "Concerns Date Time Field text (EN) is required" },
    },
    {
      fieldName: "Concerns Location of Incident Field text (EN)",
      fieldValue: "labelData.concerns.locationOfIncidentFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_concerns_locationOfIncidentFieldText",
      formType: "input",
      label: "Concerns Location of Incident Field text (EN)",
      placeholder: "Enter Concerns Location of Incident Field text (EN)",
      validation: { required: "Concerns Location of Incident Field text (EN) is required" },
    },
    {
      fieldName: "Concerns Details Field text (EN)",
      fieldValue: "labelData.concerns.detailsFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_concerns_detailsFieldText",
      formType: "input",
      label: "Concerns Details Field text (EN)",
      placeholder: "Enter Concerns Details Field text (EN)",
      validation: { required: "Concerns Details Field text (EN) is required" },
    },
    {
      fieldName: "Concerns Others Parties Involved Field text (EN)",
      fieldValue: "labelData.concerns.otherPartiesInvolvedFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_concerns_otherPartiesInvolvedFieldText",
      formType: "input",
      label: "Concerns Others Parties Involved Field text (EN)",
      placeholder: "Enter Concerns Others Parties Involved Field text (EN)",
      validation: { required: "Concerns Others Parties Involved Field text (EN) is required" },
    },
    {
      fieldName: "Concerns Name of Witness(es) Field text (EN)",
      fieldValue: "labelData.concerns.namesOfWitnessesInvolvedFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_concerns_namesOfWitnessesInvolvedFieldText",
      formType: "input",
      label: "Concerns Name of Witness(es) Field text (EN)",
      placeholder: "Enter Concerns Name of Witness(es) Field text (EN)",
      validation: { required: "Concerns Name of Witness(es) Field text (EN) is required" },
    },
    {
      fieldName: "Your Particulars Title text (EN)",
      fieldValue: "labelData.yourParticulars.titleText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_yourParticulars_titleText",
      formType: "input",
      label: "Your Particulars Title text (EN)",
      placeholder: "Enter Your Particulars Title text (EN)",
      validation: { required: "Your Particulars Title text (EN) is required" },
    },
    {
      fieldName: "Your Particulars Full Name Field text (EN)",
      fieldValue: "labelData.yourParticulars.fullnameFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_yourParticulars_fullnameFieldText",
      formType: "input",
      label: "Your Particulars Full Name Field text (EN)",
      placeholder: "Enter Your Particulars Full Name Field text (EN)",
      validation: { required: "Your Particulars Full Name Field text (EN) is required" },
    },
    {
      fieldName: "Your Particulars Staff No. (MAHB employee) text (EN)",
      fieldValue: "labelData.yourParticulars.staffNoFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_yourParticulars_staffNoFieldText",
      formType: "input",
      label: "Your Particulars Staff No. (MAHB employee) text (EN)",
      placeholder: "Enter Your Particulars Staff No. (MAHB employee) text (EN)",
      validation: { required: "Your Particulars Staff No. (MAHB employee) text (EN) is required" },
    },
    {
      fieldName: "Your Particulars Contact No. Field text (EN)",
      fieldValue: "labelData.yourParticulars.contactNoFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_yourParticulars_contactNoFieldText",
      formType: "input",
      label: "Your Particulars Contact No. Field text (EN)",
      placeholder: "Enter Your Particulars Contact No. Field text (EN)",
      validation: { required: "Your Particulars Contact No. Field text (EN) is required" },
    },
    {
      fieldName: "Your Particulars Email text (EN)",
      fieldValue: "labelData.yourParticulars.emailFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_yourParticulars_emailFieldText",
      formType: "input",
      label: "Your Particulars Email text (EN)",
      placeholder: "Enter Your Particulars Email text (EN)",
      validation: { required: "Your Particulars Email text (EN) is required" },
    },
    {
      fieldName: "Your Particulars Company Name Field text (EN)",
      fieldValue: "labelData.yourParticulars.companyNameFieldText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_yourParticulars_companyNameFieldText",
      formType: "input",
      label: "Your Particulars Company Name Field text (EN)",
      placeholder: "Enter Your Particulars Company Name Field text (EN)",
      validation: { required: "Your Particulars Company Name Field text (EN) is required" },
    },
    {
      fieldName: "Confidentiality text (EN)",
      fieldValue: "labelData.confidentialityText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_confidentialityText",
      formType: "input",
      label: "Confidentiality text (EN)",
      placeholder: "Enter Confidentiality text (EN)",
      validation: { required: "Confidentiality text (EN) is required" },
    },
    {
      fieldName: "Captcha Title text (EN)",
      fieldValue: "labelData.captcha.titleText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_captcha_titleText",
      formType: "input",
      label: "Captcha Title text (EN)",
      placeholder: "Enter Captcha Title text (EN)",
      validation: { required: "Captcha Title text (EN) is required" },
    },
    {
      fieldName: "Captcha Help text (EN)",
      fieldValue: "labelData.captcha.helpText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_captcha_helpText",
      formType: "input",
      label: "Captcha Help text (EN)",
      placeholder: "Enter Captcha Help text (EN)",
      validation: { required: "Captcha Help text (EN) is required" },
    },
    {
      fieldName: "Captcha New Captcha text (EN)",
      fieldValue: "labelData.captcha.newCaptchaText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_captcha_newCaptchaText",
      formType: "input",
      label: "Captcha New Captcha text (EN)",
      placeholder: "Enter Captcha New Captcha text (EN)",
      validation: { required: "Captcha New Captcha text (EN) is required" },
    },
    {
      fieldName: "Submit Button Text (EN)",
      fieldValue: "labelData.submitButtonText",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_submitButtonText",
      formType: "input",
      label: "Submit Button text (EN)",
      placeholder: "Enter Submit Button text (EN)",
      validation: { required: "Submit Button text (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "data.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      validation: {},
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "data.description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      validation: {},
    },
    {
      fieldName: "After Submit Success Message (MS)",
      fieldValue: "data.afterSubmit.succesMessage",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_after_submit_succesMessage",
      formType: "input",
      label: "After Submit Success Message (MS)",
      placeholder: "Enter After Submit Success Message (MS)",
      validation: {},
    },
    {
      fieldName: "After Submit Appreciation Message (MS)",
      fieldValue: "data.afterSubmit.appreciationMessage",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_after_submit_appreciationMessage",
      formType: "input",
      label: "After Submit Appreciation Message (MS)",
      placeholder: "Enter After Submit Appreciation Message (MS)",
      validation: {},
    },
    {
      fieldName: "After Submit Back To Form (MS)",
      fieldValue: "data.afterSubmit.backToForm",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_after_submit_backToForm",
      formType: "input",
      label: "After Submit Back To Form Message (MS)",
      placeholder: "Enter After Submit Back To Form Message (MS)",
      validation: {},
    },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   validation: {},
    // },
    {
      fieldName: "Person Title text (MS)",
      fieldValue: "labelData.persons.titleText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_persons_titleText",
      formType: "input",
      label: "Person Title text (MS)",
      placeholder: "Enter Person Title text (MS)",
      validation: {},
    },
    {
      fieldName: "Person Name Field text (MS)",
      fieldValue: "labelData.persons.nameFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_persons_nameFieldText",
      formType: "input",
      label: "Person Name Field text (MS)",
      placeholder: "Enter Person Name Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Person Designation Field text (MS)",
      fieldValue: "labelData.persons.designationFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_persons_designationFieldText",
      formType: "input",
      label: "Person Designation Field text (MS)",
      placeholder: "Enter Person Designation Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Person Division/Unit Field text (MS)",
      fieldValue: "labelData.persons.divisionOrUnitFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_persons_divisionOrUnitFieldText",
      formType: "input",
      label: "Person Division/Unit Field text (MS)",
      placeholder: "Enter Person Division/Unit Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Person Company/Airport text (MS)",
      fieldValue: "labelData.persons.companyOrAirportFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_persons_companyOrAirportFieldText",
      formType: "input",
      label: "Person Company/Airport text (MS)",
      placeholder: "Enter Person Company/Airport text (MS)",
      validation: {},
    },
    {
      fieldName: "Concerns Title text (MS)",
      fieldValue: "labelData.concerns.titleText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_concerns_titleText",
      formType: "input",
      label: "Concerns Title text (MS)",
      placeholder: "Enter Concerns Title text (MS)",
      validation: {},
    },
    {
      fieldName: "Concerns Date Time Field text (MS)",
      fieldValue: "labelData.concerns.dateTimeFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_concerns_dateTimeFieldText",
      formType: "input",
      label: "Concerns Date Time Field text (MS)",
      placeholder: "Enter Concerns Date Time Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Concerns Location of Incident Field text (MS)",
      fieldValue: "labelData.concerns.locationOfIncidentFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_concerns_locationOfIncidentFieldText",
      formType: "input",
      label: "Concerns Location of Incident Field text (MS)",
      placeholder: "Enter Concerns Location of Incident Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Concerns Details Field text (MS)",
      fieldValue: "labelData.concerns.detailsFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_concerns_detailsFieldText",
      formType: "input",
      label: "Concerns Details Field text (MS)",
      placeholder: "Enter Concerns Details Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Concerns Others Parties Involved Field text (MS)",
      fieldValue: "labelData.concerns.otherPartiesInvolvedFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_concerns_otherPartiesInvolvedFieldText",
      formType: "input",
      label: "Concerns Others Parties Involved Field text (MS)",
      placeholder: "Enter Concerns Others Parties Involved Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Concerns Name of Witness(es) Field text (MS)",
      fieldValue: "labelData.concerns.namesOfWitnessesInvolvedFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_concerns_namesOfWitnessesInvolvedFieldText",
      formType: "input",
      label: "Concerns Name of Witness(es) Field text (MS)",
      placeholder: "Enter Concerns Name of Witness(es) Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Title text (MS)",
      fieldValue: "labelData.yourParticulars.titleText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_yourParticulars_titleText",
      formType: "input",
      label: "Your Particulars Title text (MS)",
      placeholder: "Enter Your Particulars Title text (MS)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Full Name Field text (MS)",
      fieldValue: "labelData.yourParticulars.fullnameFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_yourParticulars_fullnameFieldText",
      formType: "input",
      label: "Your Particulars Full Name Field text (MS)",
      placeholder: "Enter Your Particulars Full Name Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Staff No. (MAHB employee) text (MS)",
      fieldValue: "labelData.yourParticulars.staffNoFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_yourParticulars_staffNoFieldText",
      formType: "input",
      label: "Your Particulars Staff No. (MAHB employee) text (MS)",
      placeholder: "Enter Your Particulars Staff No. (MAHB employee) text (MS)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Contact No. Field text (MS)",
      fieldValue: "labelData.yourParticulars.contactNoFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_yourParticulars_contactNoFieldText",
      formType: "input",
      label: "Your Particulars Contact No. Field text (MS)",
      placeholder: "Enter Your Particulars Contact No. Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Email text (MS)",
      fieldValue: "labelData.yourParticulars.emailFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_yourParticulars_emailFieldText",
      formType: "input",
      label: "Your Particulars Email text (MS)",
      placeholder: "Enter Your Particulars Email text (MS)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Company Name Field text (MS)",
      fieldValue: "labelData.yourParticulars.companyNameFieldText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_yourParticulars_companyNameFieldText",
      formType: "input",
      label: "Your Particulars Company Name Field text (MS)",
      placeholder: "Enter Your Particulars Company Name Field text (MS)",
      validation: {},
    },
    {
      fieldName: "Confidentiality text (MS)",
      fieldValue: "labelData.confidentialityText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_confidentialityText",
      formType: "input",
      label: "Confidentiality text (MS)",
      placeholder: "Enter Confidentiality text (MS)",
      validation: {},
    },
    {
      fieldName: "Captcha Title text (MS)",
      fieldValue: "labelData.captcha.titleText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_captcha_titleText",
      formType: "input",
      label: "Captcha Title text (MS)",
      placeholder: "Enter Captcha Title text (MS)",
      validation: {},
    },
    {
      fieldName: "Captcha Help text (MS)",
      fieldValue: "labelData.captcha.helpText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_captcha_helpText",
      formType: "input",
      label: "Captcha Help text (MS)",
      placeholder: "Enter Captcha Help text (MS)",
      validation: {},
    },
    {
      fieldName: "Captcha New Captcha text (MS)",
      fieldValue: "labelData.captcha.newCaptchaText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_captcha_newCaptchaText",
      formType: "input",
      label: "Captcha New Captcha text (MS)",
      placeholder: "Enter Captcha New Captcha text (MS)",
      validation: {},
    },
    {
      fieldName: "Submit Button Text (MS)",
      fieldValue: "labelData.submitButtonText",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_submitButtonText",
      formType: "input",
      label: "Submit Button text (MS)",
      placeholder: "Enter Submit Button text (MS)",
      validation: {},
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "data.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      validation: {},
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "data.description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_description",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      validation: {},
    },
    {
      fieldName: "After Submit Success Message (ZH)",
      fieldValue: "data.afterSubmit.succesMessage",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_after_submit_succesMessage",
      formType: "input",
      label: "After Submit Success Message (ZH)",
      placeholder: "Enter After Submit Success Message (ZH)",
      validation: {},
    },
    {
      fieldName: "After Submit Appreciation Message (ZH)",
      fieldValue: "data.afterSubmit.appreciationMessage",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_after_submit_appreciationMessage",
      formType: "input",
      label: "After Submit Appreciation Message (ZH)",
      placeholder: "Enter After Submit Appreciation Message (ZH)",
      validation: {},
    },
    {
      fieldName: "After Submit Back To Form (ZH)",
      fieldValue: "data.afterSubmit.backToForm",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_after_submit_backToForm",
      formType: "input",
      label: "After Submit Back To Form Message (ZH)",
      placeholder: "Enter After Submit Back To Form Message (ZH)",
      validation: {},
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_next_page_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
    {
      fieldName: "Person Title text (ZH)",
      fieldValue: "labelData.persons.titleText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_persons_titleText",
      formType: "input",
      label: "Person Title text (ZH)",
      placeholder: "Enter Person Title text (ZH)",
      validation: {},
    },
    {
      fieldName: "Person Name Field text (ZH)",
      fieldValue: "labelData.persons.nameFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_persons_nameFieldText",
      formType: "input",
      label: "Person Name Field text (ZH)",
      placeholder: "Enter Person Name Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Person Designation Field text (ZH)",
      fieldValue: "labelData.persons.designationFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_persons_designationFieldText",
      formType: "input",
      label: "Person Designation Field text (ZH)",
      placeholder: "Enter Person Designation Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Person Division/Unit Field text (ZH)",
      fieldValue: "labelData.persons.divisionOrUnitFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_persons_divisionOrUnitFieldText",
      formType: "input",
      label: "Person Division/Unit Field text (ZH)",
      placeholder: "Enter Person Division/Unit Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Person Company/Airport text (ZH)",
      fieldValue: "labelData.persons.companyOrAirportFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_persons_companyOrAirportFieldText",
      formType: "input",
      label: "Person Company/Airport text (ZH)",
      placeholder: "Enter Person Company/Airport text (ZH)",
      validation: {},
    },
    {
      fieldName: "Concerns Title text (ZH)",
      fieldValue: "labelData.concerns.titleText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_concerns_titleText",
      formType: "input",
      label: "Concerns Title text (ZH)",
      placeholder: "Enter Concerns Title text (ZH)",
      validation: {},
    },
    {
      fieldName: "Concerns Date Time Field text (ZH)",
      fieldValue: "labelData.concerns.dateTimeFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_concerns_dateTimeFieldText",
      formType: "input",
      label: "Concerns Date Time Field text (ZH)",
      placeholder: "Enter Concerns Date Time Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Concerns Location of Incident Field text (ZH)",
      fieldValue: "labelData.concerns.locationOfIncidentFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_concerns_locationOfIncidentFieldText",
      formType: "input",
      label: "Concerns Location of Incident Field text (ZH)",
      placeholder: "Enter Concerns Location of Incident Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Concerns Details Field text (ZH)",
      fieldValue: "labelData.concerns.detailsFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_concerns_detailsFieldText",
      formType: "input",
      label: "Concerns Details Field text (ZH)",
      placeholder: "Enter Concerns Details Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Concerns Others Parties Involved Field text (ZH)",
      fieldValue: "labelData.concerns.otherPartiesInvolvedFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_concerns_otherPartiesInvolvedFieldText",
      formType: "input",
      label: "Concerns Others Parties Involved Field text (ZH)",
      placeholder: "Enter Concerns Others Parties Involved Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Concerns Name of Witness(es) Field text (ZH)",
      fieldValue: "labelData.concerns.namesOfWitnessesInvolvedFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_concerns_namesOfWitnessesInvolvedFieldText",
      formType: "input",
      label: "Concerns Name of Witness(es) Field text (ZH)",
      placeholder: "Enter Concerns Name of Witness(es) Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Title text (ZH)",
      fieldValue: "labelData.yourParticulars.titleText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_yourParticulars_titleText",
      formType: "input",
      label: "Your Particulars Title text (ZH)",
      placeholder: "Enter Your Particulars Title text (ZH)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Full Name Field text (ZH)",
      fieldValue: "labelData.yourParticulars.fullnameFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_yourParticulars_fullnameFieldText",
      formType: "input",
      label: "Your Particulars Full Name Field text (ZH)",
      placeholder: "Enter Your Particulars Full Name Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Staff No. (MAHB employee) text (ZH)",
      fieldValue: "labelData.yourParticulars.staffNoFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_yourParticulars_staffNoFieldText",
      formType: "input",
      label: "Your Particulars Staff No. (MAHB employee) text (ZH)",
      placeholder: "Enter Your Particulars Staff No. (MAHB employee) text (ZH)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Contact No. Field text (ZH)",
      fieldValue: "labelData.yourParticulars.contactNoFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_yourParticulars_contactNoFieldText",
      formType: "input",
      label: "Your Particulars Contact No. Field text (ZH)",
      placeholder: "Enter Your Particulars Contact No. Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Email text (ZH)",
      fieldValue: "labelData.yourParticulars.emailFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_yourParticulars_emailFieldText",
      formType: "input",
      label: "Your Particulars Email text (ZH)",
      placeholder: "Enter Your Particulars Email text (ZH)",
      validation: {},
    },
    {
      fieldName: "Your Particulars Company Name Field text (ZH)",
      fieldValue: "labelData.yourParticulars.companyNameFieldText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_yourParticulars_companyNameFieldText",
      formType: "input",
      label: "Your Particulars Company Name Field text (ZH)",
      placeholder: "Enter Your Particulars Company Name Field text (ZH)",
      validation: {},
    },
    {
      fieldName: "Confidentiality text (ZH)",
      fieldValue: "labelData.confidentialityText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_confidentialityText",
      formType: "input",
      label: "Confidentiality text (ZH)",
      placeholder: "Enter Confidentiality text (ZH)",
      validation: {},
    },
    {
      fieldName: "Captcha Title text (ZH)",
      fieldValue: "labelData.captcha.titleText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_captcha_titleText",
      formType: "input",
      label: "Captcha Title text (ZH)",
      placeholder: "Enter Captcha Title text (ZH)",
      validation: {},
    },
    {
      fieldName: "Captcha Help text (ZH)",
      fieldValue: "labelData.captcha.helpText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_captcha_helpText",
      formType: "input",
      label: "Captcha Help text (ZH)",
      placeholder: "Enter Captcha Help text (ZH)",
      validation: {},
    },
    {
      fieldName: "Captcha New Captcha text (ZH)",
      fieldValue: "labelData.captcha.newCaptchaText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_captcha_newCaptchaText",
      formType: "input",
      label: "Captcha New Captcha text (ZH)",
      placeholder: "Enter Captcha New Captcha text (ZH)",
      validation: {},
    },
    {
      fieldName: "Submit Button Text (ZH)",
      fieldValue: "labelData.submitButtonText",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_submitButtonText",
      formType: "input",
      label: "Submit Button text (ZH)",
      placeholder: "Enter Submit Button text (ZH)",
      validation: {},
    },
    //     {
    //       fieldName: "Next Page Name (EN)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (EN)",
    //       placeholder: "Enter Next Page Name (EN)",
    //       validation: { required: " Next Page Name (EN) is required" },
    //     },
    //     {
    //       fieldName: "Next Page Name (MS)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_malay",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_ms_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (MS)",
    //       placeholder: "Enter Next Page Name (MS)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Name (ZH)",
    //       fieldValue: "data.nextPage.name",
    //       parseField: "field_content_mandarin",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_zh_next_page_name",
    //       formType: "input",
    //       label: "Next Page Name (ZH)",
    //       placeholder: "Enter Next Page Name (ZH)",
    //       validation: {},
    //     },
    //     {
    //       fieldName: "Next Page Link",
    //       fieldValue: "data.nextPage.link",
    //       parseField: "field_content_english",
    //       className: "col-span-6",
    //       type: "content",
    //       name: "field_content_english_next_page_link",
    //       formType: "input",
    //       label: "Next Page Link",
    //       placeholder: "Enter Next Page Link",
    //       validation: { required: "Next Page Link is required", validate: (value: string) => {
    //   const trimmed = value.trim();
    //   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
    //   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    //     return "Looks like an external link. Please use an in-app page link, such as /example";
    //   }
    //   return true;
    // } },
    //     },
  ],
  reportingConcernPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      // validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  reportingConcernNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: " Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_next_page_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_next_page_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      validation: {},
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_page_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter Next Page Link",
      validation: {
        required: "Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
};
